import { render, staticRenderFns } from "./iqvia.vue?vue&type=template&id=19fb7af0&scoped=true&v-once=true"
import script from "./iqvia.vue?vue&type=script&lang=js"
export * from "./iqvia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb7af0",
  null
  
)

export default component.exports